import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67032e20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10 mb-10 flex flex-col content-center" }
const _hoisted_2 = { class: "mb-5 flex flex-row items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text mr-5" }, "Monthly", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Annual", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text ml-5" }, "Annual", -1))
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-2 gap-x-8"
}
const _hoisted_7 = { class: "col-span-3 md:col-span-1 h-full" }
const _hoisted_8 = { class: "flex flex-col h-full" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold text-center" }, " Free ", -1))
const _hoisted_10 = { class: "p-10 text-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "col-span-3 md:col-span-1 h-full" }
const _hoisted_14 = { class: "flex flex-col h-full" }
const _hoisted_15 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_16 = { class: "block mt-1 text-sm" }
const _hoisted_17 = { class: "seats-input mt-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, "Number of users", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "block text-2xl text-center text-teal font-bold mt-2"
}
const _hoisted_21 = {
  key: 1,
  class: "text-lg text-center text-teal font-bold -mt-1"
}
const _hoisted_22 = {
  key: 2,
  class: "text-base text-center mt-2"
}
const _hoisted_23 = {
  key: 3,
  class: "text-base text-center mt-2"
}
const _hoisted_24 = {
  key: 4,
  class: "flex justify-center"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg dark:bg-green-200 dark:text-green-800",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "inline flex-shrink-0 mr-3 w-5 h-5",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Contact our sales team.")
  ])
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "flex flex-col mt-2 items-center"
}
const _hoisted_28 = {
  key: 0,
  class: "mt-4 grid grid-cols-2 gap-x-8"
}
const _hoisted_29 = { class: "mb-4 col-span-2 md:col-span-1" }
const _hoisted_30 = { class: "mb-4 col-span-2 md:col-span-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold" }, "Selected Plan", -1))
const _hoisted_32 = { class: "mt-2" }
const _hoisted_33 = {
  key: 0,
  class: "promo-container"
}
const _hoisted_34 = { class: "flex flex-row items-baseline mt-2" }
const _hoisted_35 = ["loadingPromo"]
const _hoisted_36 = {
  key: 0,
  class: "animate-spin -mr-1 ml-3 h-5 w-5 text-blue",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "#19B8D1",
  "stroke-width": "4"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "#19B8D1",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mp-4 col-span-2 md:col-span-1" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-sm",
    style: {"color":"darkgray"}
  }, " Promo code is not applied before subscription is purchased. Valid only for first-time customers. ")
], -1))
const _hoisted_41 = {
  key: 1,
  class: "flex flex-row items-baseline mt-2"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg" }, "Total:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_44 = { class: "text-lg" }
const _hoisted_45 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_46 = {
  class: "flex p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800",
  role: "alert"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_48 = { class: "font-medium" }
const _hoisted_49 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_50 = {
  class: "flex p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg dark:bg-green-200 dark:text-green-800",
  role: "alert"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "inline flex-shrink-0 mr-3 w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_52 = { class: "font-medium" }
const _hoisted_53 = {
  key: 3,
  class: "flex flex-row justify-end mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserPaymentEntry = _resolveComponent("UserPaymentEntry")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Switch, {
          modelValue: _ctx.annual,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.annual) = $event)),
          class: _normalizeClass([_ctx.annual ? 'bg-teal' : 'bg-gray-500', "relative h-9 w-32 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200"])
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("span", {
              class: _normalizeClass([_ctx.annual ? 'translate-x-8' : '-translate-x-8', "pointer-events-none inline-block h-8 w-8 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["modelValue", "class"]),
        _hoisted_5
      ]),
      (_ctx.plan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(" Visit our "),
                  _createVNode(_component_router_link, {
                    class: "link",
                    to: "/marketplace"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("marketplace")
                    ]),
                    _: 1
                  }),
                  _hoisted_11,
                  _hoisted_12,
                  _createTextVNode(" With $500,000 in wellness savings ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h3", {
                  class: _normalizeClass(["text-xl font-bold text-center", _ctx.tierIsSelected(_ctx.plan.subscriptionLevel) ? 'text-teal' : 'text-black'])
                }, _toDisplayString(_ctx.plan.marketingCopy.title), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["p-2 border-2 rounded-lg flex flex-col text-center h-full", _ctx.tierIsSelected(_ctx.plan.subscriptionLevel)
                            ? 'border-teal'
                            : 'border-gray-500'
                            ]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectPlan(_ctx.plan)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan.marketingCopy.benefits, (benefit, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: benefit
                    }, [
                      (index != 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, "+"))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", _hoisted_16, _toDisplayString(benefit), 1)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = () => _ctx.remove('STARTER')),
                      class: "remove"
                    }, " - "),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.seats['STARTER']) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.seats['STARTER']]
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = () => _ctx.add('STARTER')),
                      class: "add"
                    }, " + ")
                  ]),
                  _hoisted_18,
                  _hoisted_19,
                  (_ctx.getPrice(_ctx.plan))
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_20, " $" + _toDisplayString(_ctx.getPrice(_ctx.plan)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.getPrice(_ctx.plan))
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_21, _toDisplayString(_ctx.annual ? '/year' : '/month'), 1))
                    : _createCommentVNode("", true),
                  (_ctx.annual && _ctx.getYearlyDiscountAmount(_ctx.plan))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, " You will save $" + _toDisplayString(_ctx.getYearlyDiscountAmount(_ctx.plan)) + "/year ", 1))
                    : (_ctx.getYearlyDiscountAmount(_ctx.plan))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                          _createElementVNode("span", {
                            class: "cursor-pointer underline",
                            onClick: _cache[4] || (_cache[4] = () => (_ctx.annual = !_ctx.annual))
                          }, "Pay annually"),
                          _createTextVNode(" to save $" + _toDisplayString(_ctx.getYearlyDiscountAmount(_ctx.plan)) + "/year ", 1)
                        ]))
                      : _createCommentVNode("", true),
                  (!_ctx.getPrice(_ctx.plan))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                    : _createCommentVNode("", true)
                ], 2),
                (_ctx.subscription && _ctx.plan && _ctx.subscription.subscriptionLevel == _ctx.plan.subscriptionLevel
                            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_ctx.selectedPlan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_UserPaymentEntry, { onUpdating: _ctx.updatingPaymentToggle }, null, 8, ["onUpdating"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.selectedPlan.marketingCopy.title) + " " + _toDisplayString(_ctx.annual ? 'annual' : 'monthly'), 1),
              (!_ctx.annual && _ctx.getPrice(_ctx.selectedPlan))
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("input", {
                        id: "promo-code",
                        maxlength: "6",
                        placeholder: "Promo code",
                        name: "promo-code",
                        type: "text",
                        onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handlePromoCode && _ctx.handlePromoCode(...args))),
                        loadingPromo: _ctx.loadingPromo
                      }, null, 40, _hoisted_35),
                      (_ctx.loadingPromo)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_36, _hoisted_39))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_40
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getPrice(_ctx.selectedPlan))
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _hoisted_42,
                    _hoisted_43,
                    _createElementVNode("h3", _hoisted_44, "$" + _toDisplayString(_ctx.getPrice(_ctx.selectedPlan)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.responseError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.responseError), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.successMsg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.successMsg), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedPlan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", null, [
              _createVNode(_component_LoadingButton, {
                loading: _ctx.loading,
                disabled: !_ctx.canPurchase,
                onClick: _ctx.purchaseTapped
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Purchase Subscription ")
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}